import React from 'react';
import { Box } from '@material-ui/core';
import { DateTimePicker } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

interface DateTimeFilterProps {
    dateFrom: Date;
    handleDateFromChange(date: MaterialUiPickersDate): void;
    dateTo: Date;
    handleDateToChange(date: MaterialUiPickersDate): void;
}

const DateTimeFilter = ({ dateFrom, handleDateFromChange, dateTo, handleDateToChange }: DateTimeFilterProps) => (
    <Box display='grid' gridAutoFlow='column' gridGap={16}>
        <DateTimePicker
            label="From"
            inputVariant='outlined'
            size='small'
            value={dateFrom}
            onChange={handleDateFromChange}
        />
        <DateTimePicker
            label="To"
            inputVariant='outlined'
            size='small'
            value={dateTo}
            onChange={handleDateToChange}
            disableFuture
        />
    </Box>
);

export default DateTimeFilter;